import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/Domain/components/Shared/Skeleton/Skeleton';

export const ArticleSheetSkeleton = () => {
  const { t } = useTranslation(['knowledge_base']);

  return (
    <div
      className="grid lg:h-full min-h-0 grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(320px,0.4fr)]"
      data-testid="article-sheet-skeleton"
      role="status"
      aria-live="polite"
    >
      <span className="sr-only">{t('knowledge_base:article.loading')}</span>
      <section className="flex lg:h-full min-h-0 min-w-0 flex-col space-y-8 pt-4 pb-2 lg:pt-6 lg:pb-0">
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="flex min-h-0 flex-1 flex-col space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="min-h-[360px] flex-1 rounded-xl" />
        </div>
      </section>
      <div className="space-y-6 pl-1 pt-4 lg:pt-6 lg:border-l lg:border-border">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-5 w-2/3" />
          </div>
        ))}
      </div>
    </div>
  );
};
